var map = {

	init: function () {
		
		$('.m-map:not(.js-map-done)').each(function () {
			var wrapper = $(this);
			var lat = parseFloat(wrapper.attr('data-latitude'));
			var lng = parseFloat(wrapper.attr('data-longitude'));
			var latLng = new google.maps.LatLng(lat, lng);
			var zoom = parseInt(wrapper.attr('data-zoom'), 10);
			var offset = parseInt(wrapper.attr('data-offset'), 10) || 0;

			// create map
			var m = new google.maps.Map(wrapper.get(0), {
				zoom: zoom > 18 ? 18 : zoom,
				mapTypeControl: false,
				scrollwheel: false,
				streetViewControl: false,
				center: latLng
			});

			// add marker
			var marker = new google.maps.Marker({
				position: latLng,
				icon: {
					url: '/images/common/map-pin.png',
					size: new google.maps.Size(32, 32),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(16, 32)
				},
				map: m,
				clickable: false
			});

			// resize
			google.maps.event.addDomListener(window, 'resize', function () {
				m.setCenterWithOffset(latLng, offset, 0);
			});

			// offset
			google.maps.Map.prototype.setCenterWithOffset = function (latlng, offsetX, offsetY) {
				var map = this;
				var ov = new google.maps.OverlayView();
				ov.onAdd = function () {
					var proj = this.getProjection();
					var aPoint = proj.fromLatLngToContainerPixel(latlng);
					aPoint.x = aPoint.x + offsetX;
					aPoint.y = aPoint.y + offsetY;
					map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
				};
				ov.draw = function () { };
				ov.setMap(this);
			};

			// set offset
			m.setCenterWithOffset(latLng, offset, 0);

			// done
			wrapper.addClass('js-map-done');
		});

	}

};

$(function () {
	map.init();
	site.doc.ajaxComplete(function () {
		map.init();
	});
});